import React from 'react'

export const IconSearch = ({ active = false }) => {
  const color = active ? '#228E82' : '#66CFC3'
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.3223" cy="9.5" r="8.5" stroke={color} strokeWidth="2" />
      <path
        d="M17.0294 15.7929L16.3223 15.0858L14.9081 16.5L15.6152 17.2071L17.0294 15.7929ZM21.1152 22.7071C21.5057 23.0976 22.1388 23.0976 22.5294 22.7071C22.9199 22.3166 22.9199 21.6834 22.5294 21.2929L21.1152 22.7071ZM16.3223 16.5L15.6152 17.2071L21.1152 22.7071L21.8223 22L22.5294 21.2929L17.0294 15.7929L16.3223 16.5Z"
        fill={color}
      />
    </svg>
  )
}
